<template>
  <div class="matrix-multiple-choice-root" v-if="rows.length > 0">
    <div
      class="matrix-multiple-choice-scroll"
      tabindex="0"
      aria-label="Tabel matrix multiple choice dapat digeser horizontal"
    >
      <table
        class="matrix-multiple-choice"
        :style="{ minWidth: tableMinWidth + 'px' }"
      >
        <colgroup>
          <col :style="{ width: rowWidth + '%' }" />
          <col
            v-for="header in headers"
            :key="'matrix-column-width-' + header.column"
            :style="{ width: header.width + '%' }"
          />
        </colgroup>
        <thead v-if="headers.length > 0">
          <tr>
            <th class="matrix-row-header"></th>
            <th
              v-for="header in headers"
              :key="'matrix-header-' + header.column"
              class="matrix-column-header notranslate"
            >
              {{ header.description }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.rowId">
            <td class="matrix-row-label">
              <span class="notranslate">{{ row.description }}</span>
            </td>
            <td
              v-for="(header, indexOption) in headers"
              :key="row.rowId + '-' + header.column"
              class="matrix-option"
            >
              <label
                class="matrix-choice"
                v-if="row.displayOptions[indexOption]"
              >
                <span class="notranslate" v-if="hasConfiguredHeaders">
                  {{ row.displayOptions[indexOption].description }}
                </span>
                <input
                  v-if="row.answerType == 'radio button'"
                  type="radio"
                  :name="'matrix-mc-' + data.id + '-' + row.rowId"
                  :value="row.displayOptions[indexOption].optionId"
                  v-model="selected[row.rowId]"
                  @change="submit(row)"
                />
                <input
                  v-else
                  type="checkbox"
                  :value="row.displayOptions[indexOption].optionId"
                  :checked="
                    selected[row.rowId].includes(
                      row.displayOptions[indexOption].optionId
                    )
                  "
                  @change="
                    toggleCheckbox(
                      row,
                      row.displayOptions[indexOption].optionId
                    )
                  "
                />
              </label>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <info-storing-answer
      :question="data"
      @resend="$emit('resend-answer', data)"
    />
  </div>
</template>

<script>
import InfoStoringAnswer from '@/components/V2/Candidat/InfoStoringAnswer.vue'

export default {
  components: {
    InfoStoringAnswer,
  },
  props: {
    data: {
      default: () => {},
    },
    sectionId: {
      default: () => {},
    },
  },
  data() {
    return {
      rows: [],
      headers: [],
      hasConfiguredHeaders: false,
      selected: {},
    }
  },
  watch: {
    data(val) {
      this.init(val)
    },
  },
  mounted() {
    this.init(this.data)
  },
  methods: {
    init(data) {
      this.rows = (data.answerList || []).map(row => {
        const answerType = row.answerType || row.answer_type || 'radio button'
        const rowId = row.rowId || row.row_id || row.id
        const options = (row.options || []).map(option => ({
          optionId: option.optionId || option.option_id || option.id,
          description: option.description,
          width: this.matrixWidth(option.width, 20),
          isAnswer: option.isAnswer || option.is_answer || false,
          column: option.column || option.optionIndex || option.option_index,
        }))

        this.$set(
          this.selected,
          rowId,
          answerType == 'checkbox'
            ? options
                .filter(option => option.isAnswer)
                .map(option => option.optionId)
            : (options.find(option => option.isAnswer) || {}).optionId || null
        )

        return {
          rowId,
          description: row.description,
          answerType,
          maxSelect: null,
          width: this.matrixWidth(row.width, 30),
          options,
        }
      })

      const configuredHeaders =
        data.matrixColumnHeaders || data.matrix_column_headers || []
      const firstRow = this.rows[0]
      const sameAllRows = this.rows.every(row => {
        return (
          firstRow &&
          row.answerType == firstRow.answerType &&
          row.maxSelect == firstRow.maxSelect &&
          row.options.length == firstRow.options.length &&
          row.options.every((option, index) => {
            return (
              firstRow.options[index] &&
              option.description == firstRow.options[index].description
            )
          })
        )
      })
      this.hasConfiguredHeaders = configuredHeaders.length > 0 || !sameAllRows
      const maxColumns = this.rows.reduce(
        (max, row) => Math.max(max, row.options.length),
        0
      )
      const sourceHeaders = configuredHeaders.length
        ? configuredHeaders
        : this.hasConfiguredHeaders
        ? Array.from({ length: maxColumns }, (_, index) => ({
            column: index + 1,
            description: this.matrixHeaderLabel(index),
            width: (
              this.rows.find(row => row.options[index]) || { options: [] }
            ).options[index].width,
          }))
        : (firstRow && firstRow.options) || []
      this.headers = sourceHeaders.map((header, index) => ({
        column:
          header.column ||
          header.headerIndex ||
          header.header_index ||
          index + 1,
        description: header.description,
        width: this.matrixWidth(header.width, 20),
      }))
      this.rows = this.rows.map(row => ({
        ...row,
        displayOptions: this.headers.map(header =>
          row.options.find(option => option.column == header.column)
        ),
      }))
    },
    matrixHeaderLabel(index) {
      let label = ''
      let value = index + 1
      while (value > 0) {
        value--
        label = String.fromCharCode(65 + (value % 26)) + label
        value = Math.floor(value / 26)
      }
      return `OPSI ${label}`
    },
    matrixWidth(value, fallback) {
      return value === null || value === undefined || value === ''
        ? fallback
        : Number(value)
    },
    toggleCheckbox(row, optionId) {
      const current = this.selected[row.rowId] || []
      const exists = current.includes(optionId)
      let next = exists
        ? current.filter(id => id != optionId)
        : current.concat(optionId)

      this.$set(this.selected, row.rowId, next)
      this.submit(row)
    },
    submit(row) {
      const value = this.selected[row.rowId]
      const selectedOptionIds = Array.isArray(value)
        ? value
        : value
        ? [value]
        : []

      this.$emit('clicked', {
        newSectionId: this.sectionId,
        newQuestionId: this.data.id,
        newAnswerId: row.rowId,
        selectedOptionIds,
        rowId: row.rowId,
        description: null,
        rating: 0,
        indexQuestion: 0,
        indexAnswer: 0,
        column: 0,
        row: row.rowId,
      })
    },
    resetAnswer() {
      this.rows.forEach(row => {
        this.$set(
          this.selected,
          row.rowId,
          row.answerType == 'checkbox' ? [] : null
        )
      })
    },
  },
  computed: {
    tableMinWidth() {
      return Math.max(560, 220 + this.headers.length * 100)
    },
    rowWidth() {
      return this.rows[0] ? this.rows[0].width : 30
    },
  },
}
</script>

<style lang="scss" scoped>
.matrix-multiple-choice-root {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.matrix-multiple-choice-scroll {
  position: relative;
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding-bottom: 6px;
  overflow-x: scroll !important;
  overflow-y: hidden;
  overscroll-behavior-inline: contain;
  scrollbar-color: #00b79f #ededed;
  scrollbar-width: thin;
  touch-action: pan-x;
  -webkit-overflow-scrolling: touch;
}

.matrix-multiple-choice-scroll::-webkit-scrollbar {
  height: 10px;
}

.matrix-multiple-choice-scroll::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #ededed;
}

.matrix-multiple-choice-scroll::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00b79f;
}

.matrix-multiple-choice {
  width: 100%;
  max-width: none;
  border-collapse: collapse;
  table-layout: fixed;
}

.matrix-row-header,
.matrix-column-header,
.matrix-row-label,
.matrix-option {
  border: 1px solid #dbdbdb;
  padding: 12px 10px;
  vertical-align: middle;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.matrix-row-header {
  text-align: left !important;
  font-weight: 700;
}

.matrix-column-header {
  text-align: center;
  font-weight: 700;
}

.matrix-row-label {
  text-align: left;
  font-weight: 600;
  line-height: 1.45;
}

.matrix-option {
  text-align: center;
}

.matrix-choice {
  display: flex;
  width: 100%;
  min-height: 54px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  text-align: center;
  line-height: 1.35;
  font-weight: 600;
  cursor: pointer;
}

.matrix-choice input {
  flex: 0 0 auto;
  margin: 0;
}
</style>
